export default "__VITE_ASSET__DdR4HjpN__"